import { ObjectType } from 'type-graphql'
import { Scope } from '../base/Scope'

@ObjectType()
export class TemplateScope extends Scope {}
